module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "fmtitle"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "pagevi"
    }
  }), _c('a', {
    attrs: {
      "id": "pagevii"
    }
  }), _c('b', [_vm._v("Contents")])])]), _vm._v(" "), _c('div', {
    staticClass: "image2"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.png"
    }
  })])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/map#map",
      "id": "rmap"
    }
  }, [_vm._v("List of Maps")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/preface#pre",
      "id": "rpre"
    }
  }, [_vm._v("Preface")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "toc1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/part1#p1",
      "id": "rp1"
    }
  }, [_c('b', [_vm._v("Part One: Starting Premises")])])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "toc2"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/ch01#c1",
      "id": "rc1"
    }
  }, [_vm._v("1. A Long View")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/ch02#c2",
      "id": "rc2"
    }
  }, [_vm._v("2. Ideas and Ideology")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "toc1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part2#p2",
      "id": "rp2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part Two: The States")])])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "toc2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch03#c3",
      "id": "rc3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Mexico")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch04#c4",
      "id": "rc4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. United States")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch05#c5",
      "id": "rc5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Canada")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch06#c6",
      "id": "rc6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Australia")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "toc1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part3#p3",
      "id": "rp3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part Three: Comparisons")])])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "toc2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch07#c7",
      "id": "rc7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Other States and Indigenous Peoples")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch08#c8",
      "id": "rc8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Conclusions from Cases Compared")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "toc2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/references#ref",
      "id": "rref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References Cited")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/recommended#rec",
      "id": "rrec",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recommended Sources on Indigenous Groups")])])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/index#ind",
      "id": "rind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21784071","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0